import { render } from "./EditCategory.vue?vue&type=template&id=99270bb0&scoped=true&ts=true"
import script from "./EditCategory.vue?vue&type=script&lang=ts"
export * from "./EditCategory.vue?vue&type=script&lang=ts"

import "./EditCategory.vue?vue&type=style&index=0&id=99270bb0&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99270bb0"]])

export default __exports__